module.exports = __webpack_public_path__ + "img/ck-ranking+4.4507462f.png";